import type { ComputedRef, InjectionKey } from 'vue';

export interface FormFieldContext {
  readonly id: ComputedRef<string>;
  readonly describedBy: ComputedRef<string | undefined>;
  readonly invalid: ComputedRef<boolean>;
  readonly required: ComputedRef<boolean>;
}

export const FORM_FIELD_KEY: InjectionKey<FormFieldContext> = Symbol('bafsy.form-field');
